import axios from '../api/axiosConfig';

const API_BASE_URL = '/api/cupl';

export const cuplAPI = {
  getAllCUPL: (params = {}) => axios.get(API_BASE_URL, { params }),
  
  getCUPLById: (id) => axios.get(`${API_BASE_URL}/${id}`),
  
  createCUPL: (data) => axios.post(API_BASE_URL, data),
  
  updateCUPL: (id, data) => axios.put(`${API_BASE_URL}/${id}`, data),
  
  markAsPaid: (id) => axios.patch(`${API_BASE_URL}/${id}/mark-paid`),
  
  markAsRejected: (id, reason) => axios.patch(`${API_BASE_URL}/${id}/mark-rejected`, { reason }),
  
  deleteCUPL: (id) => axios.delete(`${API_BASE_URL}/${id}`),
  
  getStatistics: (query = '') => axios.get(`${API_BASE_URL}/stats/summary${query}`),
  
  getChartStats: (query = '') => axios.get(`${API_BASE_URL}/stats/charts${query}`),

  getCuplsWithoutSoat: () => axios.get(`${API_BASE_URL}/pending/no-soat`),

  bypassSoat: (id, reason) => axios.post(`${API_BASE_URL}/${id}/bypass-soat`, { reason }),
};
